import { orgManagementClient, reportClient } from 'api-clients';
import getActiveMembersSuggestions from './get-active-members/get-active-members-suggestions';
import getApplicationsOwners from './get-applications-owners/get-applications-owners';
import modifyApplicationsOwners from './modify-applications-owners/modify-applications-owners';
import getApplicationsOwnersByAppIds from './get-app-owners-by-appIds/get-app-owners-by-appIds';
import setApplicationsOwnersByRole from './set-applications-owners-by-role/set-applications-owners-by-role';

const applicationOwnerService = {
  getApplicationsOwners: getApplicationsOwners(reportClient),
  modifyApplicationsOwners: modifyApplicationsOwners(reportClient),
  getActiveMembers: getActiveMembersSuggestions(orgManagementClient),
  getApplicationsOwnersByAppIds: getApplicationsOwnersByAppIds(reportClient),
  setApplicationsOwnersByRole: setApplicationsOwnersByRole(reportClient),
};

export default applicationOwnerService;
